// function updateWishlistCount() {
//   const wishlist = JSON.parse(localStorage.getItem('shopify_wishlist')) || [];
//   const countElement = document.getElementById('wishlist-count');
//   if (countElement) {
//     countElement.textContent = wishlist.length;
//   }
// }

// document.addEventListener('DOMContentLoaded', function () {
//   updateWishlistCount();

//   const buttons = document.querySelectorAll('.wishlist-button');
//   const wishlistKey = 'shopify_wishlist';
//   let wishlist = JSON.parse(localStorage.getItem(wishlistKey)) || [];

//   buttons.forEach(button => {
//     const handle = button.dataset.productHandle;

//     // Set initial state
//     if (wishlist.includes(handle)) {
//       button.classList.add('in-wishlist');
//       button.textContent = '💖 Wishlisted';
//     }

//     button.addEventListener('click', () => {
//       if (wishlist.includes(handle)) {
//         wishlist = wishlist.filter(item => item !== handle);
//         button.textContent = '❤️ Add to Wishlist';
//         button.classList.remove('in-wishlist');
//       } else {
//         wishlist.push(handle);
//         button.textContent = '💖 Wishlisted';
//         button.classList.add('in-wishlist');
//       }

//       localStorage.setItem(wishlistKey, JSON.stringify(wishlist));
//       updateWishlistCount();
//     });
//   });
// });


  function updateWishlistCount() {
    const wishlist = JSON.parse(localStorage.getItem("shopify_wishlist")) || [];
    const count = wishlist.length;

    document.querySelectorAll(".wishlist-count").forEach(el => {
      el.textContent = count;
    });

    const mobileEl = document.getElementById("wishlist-count-mobile");
    if (mobileEl) mobileEl.textContent = count;
  }

  function addToWishlist(buttonEl) {
    const handle = buttonEl.dataset.handle;
    if (!handle) return;

    let wishlist = JSON.parse(localStorage.getItem("shopify_wishlist")) || [];

    // Toggle functionality: remove if exists, add if not
    if (wishlist.includes(handle)) {
      wishlist = wishlist.filter(item => item !== handle);
      localStorage.setItem("shopify_wishlist", JSON.stringify(wishlist));
      updateButtonState(buttonEl, false);
    } else {
      wishlist.push(handle);
      localStorage.setItem("shopify_wishlist", JSON.stringify(wishlist));
      updateButtonState(buttonEl, true);
    }

    updateWishlistCount();
    updateWishlistButtons();
  }

  function updateButtonState(buttonEl, isInWishlist) {
    if (isInWishlist) {
      buttonEl.innerHTML = "💖 Wishlisted";
      buttonEl.classList.add("wishlist-disabled");
      buttonEl.classList.add("in-wishlist");
    } else {
      buttonEl.innerHTML = "❤️ Wishlist";
      buttonEl.classList.remove("wishlist-disabled");
      buttonEl.classList.remove("in-wishlist");
    }
  }

  function updateWishlistButtons() {
    const wishlist = JSON.parse(localStorage.getItem("shopify_wishlist")) || [];

    document.querySelectorAll(".wishlist-btn").forEach(btn => {
      const handle = btn.dataset.handle;
      if (handle) {
        const isInWishlist = wishlist.includes(handle);
        updateButtonState(btn, isInWishlist);
      }
    });
  }

  document.addEventListener("DOMContentLoaded", () => {
    updateWishlistCount();
    updateWishlistButtons();
    setTimeout(() => {
      updateWishlistCount();
      updateWishlistButtons();
    }, 500);
  });

  window.addToWishlist = addToWishlist;
  window.updateWishlistCount = updateWishlistCount;


 